var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconCheck18 = function SvgAIconCheck18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 5L7.46905 12.6971C7.33612 12.8727 7.13276 12.9825 6.91168 12.9981C6.6906 13.0137 6.47358 12.9335 6.31686 12.7783L4.7998 11.2763",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconCheck18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMy4yOTk4IDVMNy40NjkwNSAxMi42OTcxQzcuMzM2MTIgMTIuODcyNyA3LjEzMjc2IDEyLjk4MjUgNi45MTE2OCAxMi45OTgxQzYuNjkwNiAxMy4wMTM3IDYuNDczNTggMTIuOTMzNSA2LjMxNjg2IDEyLjc3ODNMNC43OTk4IDExLjI3NjMiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";